/**
 * useChargerDatabase Hook
 *
 * Encapsulates charger database fetch for the ChargerConfig section.
 */

import { useState, useEffect } from 'react';
import { useAuth } from '@vortx/shared-ui';
import * as evService from '@vortx/shared-ui/src/services/evProjectService';

export function useChargerDatabase() {
    const { currentUser } = useAuth();

    const [chargers, setChargers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!currentUser) return;

        const load = async () => {
            try {
                setLoading(true);
                const data = await evService.getChargerDatabase(currentUser);
                setChargers(data.chargers || []);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [currentUser]);

    return { chargers, loading, error };
}
